import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.services';

@Component({
  selector: 'app-buy-properties',
  templateUrl: './buy-properties.component.html',
  styleUrls: ['./buy-properties.component.css']
})
export class BuyPropertiesComponent implements OnInit {

  allPropertyList: Array<any> = []
  propertyList: Array<any> = []
  categoryList: Array<any> = []
  selectedCategory: string = 'All'
  constructor(private _apiService : ApiService){

    this._apiService.getCategoryList().subscribe((res) => {
      this.categoryList = res.data;
    });

    this._apiService.getAllPropertyForSale().subscribe((res) => {
      this.allPropertyList = res.data;
      this.propertyList = res.data;
    });
  }

  ngOnInit(): void {
    
  }

  filterProperty(searchText:string):void{
    if(searchText == 'All'){
      this.propertyList = this.allPropertyList;
    }
    else if(searchText == 'Ready'){
      this.propertyList = this.allPropertyList.filter(x => x.isReadyForPossession);
    }
    else if(searchText == 'OffPlan'){
      this.propertyList = this.allPropertyList.filter(x => !x.isReadyForPossession);
    }
    else if (searchText == 'Category' && this.selectedCategory != 'All') {
      this.propertyList = this.allPropertyList.filter(x => x.category == this.selectedCategory);
    }
    else{
      this.propertyList = this.allPropertyList;
    }
  }
}
